"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _console = require("@instructure/console");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _findDOMNode = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/findDOMNode"));

var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));

var _requestAnimationFrame = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/requestAnimationFrame"));

var _getElementType = _interopRequireDefault(require("@instructure/ui-utils/lib/react/getElementType"));

var _FocusRegionManager = _interopRequireDefault(require("../../utils/FocusRegionManager"));

var _dec, _class, _class2, _temp;

/**
---
category: components/utilities
---
**/
var Dialog = (_dec = (0, _deprecated.default)('5.0.0', {
  applicationElement: true
}, 'Elements outside of the `<Dialog />` are now hidden from screen readers automatically. ' + 'when `shouldContainFocus` is set to `true` or `screenreader`. The `liveRegion` prop can ' + 'be used to specify any elements that should not be hidden'), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Dialog, _Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this._raf = [];
    _this._focusRegion = null;

    _this.getRef = function (el) {
      _this._root = el;
    };

    return _this;
  }

  (0, _createClass2.default)(Dialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;

      if (open && !prevProps.open) {
        this.open();
      } else if (!open && prevProps.open) {
        this.close();
      }

      if (this._focusRegion) {
        this._focusRegion.updateElement(this.contentElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.open) {
        this.close();
      }

      this._raf.forEach(function (request) {
        return request.cancel();
      });

      this._raf = [];
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      var _this$props = this.props,
          open = _this$props.open,
          contentElement = _this$props.contentElement,
          options = (0, _objectWithoutProperties2.default)(_this$props, ["open", "contentElement"]);

      this._raf.push((0, _requestAnimationFrame.default)(function () {
        _this2._focusRegion = _FocusRegionManager.default.activateRegion(_this2.contentElement, (0, _objectSpread2.default)({}, options));
      }));
    }
  }, {
    key: "close",
    value: function close() {
      if (this._focusRegion) {
        _FocusRegionManager.default.blurRegion(this.contentElement, this._focusRegion.id);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (!this.props.open || !this.contentElement) {
        /*#__PURE__*/
        (
        /*#__PURE__*/
        0, _console.error)(false, '[Dialog] Can\'t focus a Dialog that isn\'t open.');
        return;
      }

      if (this._focusRegion) {
        _FocusRegionManager.default.focusRegion(this.contentElement, this._focusRegion.id);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (!this.props.open || !this.contentElement) {
        /*#__PURE__*/
        (
        /*#__PURE__*/
        0, _console.error)(false, '[Dialog] Can\'t blur a Dialog that isn\'t open.');
        return;
      }

      this.close();
    }
  }, {
    key: "render",
    value: function render() {
      var ElementType = (0, _getElementType.default)(Dialog, this.props);
      return this.props.open ? _react.default.createElement(ElementType, Object.assign({}, (0, _passthroughProps.omitProps)(this.props, Dialog.propTypes), {
        ref: this.getRef,
        role: this.props.label ? 'dialog' : null,
        "aria-label": this.props.label,
        className: this.props.className // eslint-disable-line react/prop-types

      }), this.props.children) : null;
    }
  }, {
    key: "contentElement",
    get: function get() {
      var contentElement = (0, _findDOMNode.default)(this.props.contentElement);

      if (!contentElement) {
        contentElement = (0, _findDOMNode.default)(this._root);
      }

      return contentElement;
    }
  }, {
    key: "focused",
    get: function get() {
      return this.contentElement && this._focusRegion && _FocusRegionManager.default.isFocused(this.contentElement, this._focusRegion.id);
    }
  }]);
  Dialog.displayName = "Dialog";
  return Dialog;
}(_react.Component), _class2.propTypes = {
  /**
   * The children to be rendered within the `<Dialog />`
   */
  children: _propTypes.default.node,

  /**
  * The element to render as the component root, `span` by default
  */
  as: _propTypes.default.elementType,
  // eslint-disable-line react/require-default-props
  display: _propTypes.default.oneOf(['auto', 'block', 'inline-block']),
  label: _propTypes.default.string,

  /**
   * Whether or not the `<Dialog />` is open
   */
  open: _propTypes.default.bool,

  /**
   * Function called when tab focus leaves the `<Dialog />` focusable content. This only
   * occurs when `shouldContainFocus` is set to false.
   */
  onBlur: _propTypes.default.func,
  onDismiss: _propTypes.default.func,

  /**
   * An element or a function returning an element to focus by default
   */
  defaultFocusElement: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * An element or a function returning an element that wraps the content of the `<Dialog />`
   */
  contentElement: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * An element, function returning an element, or array of elements that will not be hidden from
   * the screen reader when the `<Dialog />` is open
   */
  liveRegion: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element, _propTypes.default.func]),
  shouldContainFocus: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['keyboard', 'screenreader'])]),
  shouldReturnFocus: _propTypes.default.bool,
  shouldCloseOnDocumentClick: _propTypes.default.bool,
  shouldCloseOnEscape: _propTypes.default.bool,
  shouldFocusOnOpen: _propTypes.default.bool
}, _class2.defaultProps = {
  children: null,
  display: void 0,
  label: void 0,
  open: false,
  shouldFocusOnOpen: true,
  shouldContainFocus: false,
  shouldReturnFocus: false,
  shouldCloseOnDocumentClick: true,
  shouldCloseOnEscape: true,
  defaultFocusElement: null,
  contentElement: null,
  liveRegion: null,
  onBlur: function onBlur(event) {},
  onDismiss: function onDismiss(event) {}
}, _temp)) || _class);
var _default = Dialog;
exports.default = _default;